/* eslint-disable global-require */
import React, { FC } from 'react';

import { styled } from '@mui/material';
import { Theme } from 'react-toastify';
import color from '../../styles/color';

const RootStyle = styled('div')`
  position: fixed;
  height: 64px;
  border-bottom: solid 1px ${color.gray03};
  display: flex;
  align-items: center;
  background-color: #fff;
  width: 100%;
  z-index: 1;
`;
const Logo = styled('img')``;
const LeftContainer = styled('div')`
  width: 240px;
  padding: 0px 20px;
`;
const RightContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0 60px;
`;
const ProfileImage = styled('div')`
  width: 44px;
  height: 44px;
  border-radius: 22px;
`;
const Container = styled('div')`
  max-width: 1040px;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export default function Header() {
  return (
    <>
      <div style={{ height: 64 }} />
      <RootStyle>
        <LeftContainer>
          <Logo
            src='/images/icons/imgLogoText.svg'
            width={126}
            height={12}
            alt='logo'
          />
        </LeftContainer>
        <RightContainer>
          <Container>
            <ProfileImage src='/images/icons/imgProfile.png' />
          </Container>
        </RightContainer>
      </RootStyle>
    </>
  );
}
